import { WifiOff, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface SlowNetworkOverlayProps {
  onDismiss: () => void;
}

export function SlowNetworkOverlay({ onDismiss }: SlowNetworkOverlayProps) {
  const { t } = useTranslation();

  return (
    <div className="absolute inset-0 z-[4] flex flex-col items-center justify-center gap-2 bg-black/75 p-6 text-center">
      <button
        onClick={onDismiss}
        aria-label={t('video_player.slow_network_dismiss')}
        className="absolute right-2 top-2 cursor-pointer border-none bg-transparent p-1 text-white/70 hover:text-white"
      >
        <X size={20} />
      </button>

      <WifiOff size={36} className="text-white" />

      <span className="text-base font-semibold text-white">
        {t('video_player.slow_network')}
      </span>

      <span className="text-[13px] text-white/75">
        {t('video_player.slow_network_hint')}
      </span>
    </div>
  );
}

